export default __webpack_public_path__ + "static/media/logo_wt.d24258ca.svg";